/* Vionine — Judge.me yorum widget'indaki Turkce alanlari Ingilizceye cevirir ve
   "Show original" ceviri baglantisini kaldirir.
   Sinifa DEGIL metnin kendisine bakiyoruz (Judge.me sinif adlari surumler arasinda degisiyor).
   Judge.me verisine, panel ayarina ve TR<->US senkronizasyonuna dokunmaz (Kural 5).
   Teshis: adrese ?viodebug=1 ekle. */
(function () {
  var DEBUG = /[?&]viodebug=1/.test(location.search);

  var MAP = {
    'yas': 'Age',
    'cilt endisesi': 'Skin Concern',
    'cilt tipi': 'Skin Type',

    '18 & 24 yas': '18–24',
    '25 & 34 yas': '25–34',
    '35 & 44 yas': '35–44',
    '45 & 54 yas': '45–54',
    '+ 45': '45+',
    '+45': '45+',
    '45 yas ve uzeri': '45+',
    '18 yas alti': 'Under 18',

    'yaslanma': 'Aging',
    'leke': 'Dark Spots',
    'akne': 'Acne',
    'kuruluk': 'Dryness',
    'ton esitsizligi': 'Uneven Tone',
    'genis gozenek': 'Enlarged Pores',
    'asiri hassas': 'Sensitive Skin',
    'hassasiyet': 'Sensitivity',
    'sivilce': 'Blemishes',
    'sivilce izi': 'Acne Scars',
    'gozenek': 'Pores',
    'matlik': 'Dullness',
    'yagli cilt': 'Oily Skin',
    'kuru cilt': 'Dry Skin',
    'karma cilt': 'Combination Skin',
    'normal cilt': 'Normal Skin',
    'kizariklik': 'Redness',
    'elastikiyet kaybi': 'Loss of Firmness',
    'ince cizgiler': 'Fine Lines',
    'siyah nokta': 'Blackheads',
    'nem kaybi': 'Dehydration',
    'gozalti morlugu': 'Dark Circles'
  };

  var HIDE_PREFIXES = [
    'show original',
    'show translation',
    'see original',
    'view original',
    'orijinali goster',
    'ceviriyi goster'
  ];

  var TR = { 'ı': 'i', 'İ': 'i', 'ş': 's', 'Ş': 's', 'ğ': 'g', 'Ğ': 'g', 'ü': 'u', 'Ü': 'u', 'ö': 'o', 'Ö': 'o', 'ç': 'c', 'Ç': 'c' };

  function key(s) {
    var t = (s || '').replace(/\u00A0/g, ' ').trim();
    var r = '';
    for (var i = 0; i < t.length; i++) { var c = t.charAt(i); r += TR[c] || c; }
    return r.toLowerCase().replace(/\s*:\s*$/, '').replace(/\s+/g, ' ').trim();
  }

  function isHideText(k) {
    for (var i = 0; i < HIDE_PREFIXES.length; i++) {
      if (k.indexOf(HIDE_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  function hideRow(startEl) {
    var el = (startEl.closest && startEl.closest('a, button, [role="button"]')) || startEl;
    var target = el;
    var up = el.parentElement;
    var guard = 0;
    while (up && guard++ < 4 && isHideText(key(up.textContent))) {
      target = up;
      up = up.parentElement;
    }
    target.style.setProperty('display', 'none', 'important');
    target.setAttribute('data-vio-en', '1');

    var sib = target.previousElementSibling;
    if (sib && !key(sib.textContent)) {
      sib.style.setProperty('display', 'none', 'important');
      sib.setAttribute('data-vio-en', '1');
    }
  }

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1, SELECT: 1 };
  var missed = {};
  var changed = 0;

  function scan(root) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim()) nodes.push(n);
    }

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var parent = node.parentElement;
      if (!parent || SKIP_TAGS[parent.tagName]) continue;
      if (parent.getAttribute('data-vio-en') === '1') continue;

      var raw = node.nodeValue;
      var k = key(raw);
      if (!k) continue;

      if (MAP[k]) {
        node.nodeValue = raw.replace(raw.trim(), MAP[k]);
        parent.setAttribute('data-vio-en', '1');
        changed++;
        continue;
      }

      if (isHideText(k)) {
        hideRow(parent);
        changed++;
        continue;
      }

      if (DEBUG && /[ışğüöçİŞĞÜÖÇ]/.test(raw) && !missed[k]) {
        missed[k] = 1;
        console.log('[vio-judgeme] sozlukte yok:', JSON.stringify(raw.trim()), '-> anahtar:', JSON.stringify(k), parent);
      }
    }
  }

  function run() {
    scan(document.body);
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) scan(all[i].shadowRoot);
    }
    if (DEBUG) console.log('[vio-judgeme] toplam degistirilen dugum:', changed);
  }

  function start() {
    run();
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; run(); }, 80);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('click', function () { setTimeout(run, 300); }, true);
    var ticks = 0;
    var timer = setInterval(function () {
      run();
      if (++ticks >= 60) clearInterval(timer);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
